<template>
  <div :class="$style.formatGroup">
    <!-- desktop -->
    <div :class="$style.desktop">
      <BaseHeading size="h6" :class="$style.heading">
        {{ data?.fields?.name }}
      </BaseHeading>
      <div
        v-for="format in data?.fields?.formats"
        :key="format?.fields?.name"
        :class="[
          $style.format,
          selectedFormatName === format?.fields?.name && $style.active,
        ]"
        @click="emit('format-selected', format)"
      >
        {{ format?.fields?.name }}
      </div>
    </div>

    <!-- mobile -->
    <div :class="$style.mobile">
      <button
        :class="[$style.formatButton, active && $style.isGroupActive]"
        @click="emit('toggle-format-group', data?.sys?.id)"
      >
        <BaseHeading size="h6" :class="$style.heading">
          {{ data?.fields?.name }}
        </BaseHeading>
        <i :class="$style.chevron">
          <IconChevronUp v-if="active" />
          <IconChevronDown v-else />
        </i>
      </button>
      <div v-if="active">
        <div
          v-for="format in data?.fields?.formats"
          :key="format?.fields?.name"
          :class="[
            $style.format,
            selectedFormatName === format?.fields?.name && $style.active,
          ]"
          @click="emit('format-selected', format)"
        >
          {{ format?.fields?.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeFormatGroupWithoutUnresolvableLinksResponse } from '~/types/contentful'

const emit = defineEmits(['format-selected', 'toggle-format-group'])

defineProps<{
  data: TypeFormatGroupWithoutUnresolvableLinksResponse
  selectedFormatName: string
  active: boolean
}>()
</script>

<style lang="scss" module>
.formatGroup {
  border-top: 1px solid var(--black-alpha10);
  padding: 18px 26px;

  .desktop {
    display: var(--display-lg-and-up);
  }

  .mobile {
    display: var(--hidden-lg-and-up);
  }

  @include media('md') {
    padding: 18px 26px;
  }

  &:last-child {
    @include media('md') {
      border-bottom: 1px solid var(--black-alpha10);
    }
  }
}

.formatButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  border: none;

  &.isGroupActive {
    margin-bottom: 11px;
  }
}

.chevron {
  display: inline-block;
  color: var(--purple-light);
  width: 11px;
  min-width: 11px;
  height: 6px;
  min-height: 6px;
  transform: scale(1.5) translateY(-6px);
}

.heading {
  color: var(--black);
  margin-bottom: 0;

  @include media('lg') {
    margin-bottom: 11px;
  }
}

.format {
  color: var(--gray-7);
  cursor: pointer;
  font-family: var(--base-font-family);
  font-size: to-rem(16px);
  font-weight: 600;
  line-height: math.div(17, 16);
  margin-left: 1rem;
  margin-bottom: 20px;

  @include media('md') {
    font-size: to-rem(24px);
    line-height: math.div(25, 24);
  }

  &.active {
    color: var(--purple-light);
  }

  &:hover,
  &:focus {
    @include media('md') {
      color: var(--purple-light);
    }
  }
}
</style>
